// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LinkedDetailsController from "./linked_details_controller"
application.register("linked-details", LinkedDetailsController)

import LocalizeDateController from "./localize_date_controller"
application.register("localize-date", LocalizeDateController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ShadowdomController from "./shadowdom_controller"
application.register("shadowdom", ShadowdomController)

import ShowHideController from "./show_hide_controller"
application.register("show-hide", ShowHideController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

